import { render } from "./ItemConfigurationWizardModal.vue?vue&type=template&id=0cb2e01c&scoped=true"
import script from "./ItemConfigurationWizardModal.vue?vue&type=script&lang=js"
export * from "./ItemConfigurationWizardModal.vue?vue&type=script&lang=js"

import "./ItemConfigurationWizardModal.vue?vue&type=style&index=0&id=0cb2e01c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb2e01c"]])

export default __exports__